export default {
    name: 'ElDescriptionsItem',
    props: {
        label: {
            type: String,
            default: ''
        },
        span: {
            type: Number,
            default: 1
        },
        contentClassName: {
            type: String,
            default: ''
        },
        contentStyle: {
            type: Object
        },
        labelClassName: {
            type: String,
            default: ''
        },
        labelStyle: {
            type: Object
        }
    },
    render() {
        return null;
    }
};